import { ChangeEvent } from 'react';
import { TextField, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AuthInputsContainer from 'components/AuthInputsContainer';
import AuthLink from 'components/AuthLink';
import AuthPage from 'components/AuthPage';
import FormCard from 'components/FormCard';
import Button from 'components/Button';
import { ROUTES } from 'navigation/constants';
import SupportButton from 'components/SupportButton';

interface ILogin {
  email: string;
  password: string;
  error: string;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: React.FormEventHandler;
}

const StyledInput = styled(TextField)({
  marginBottom: 12,
});

const StyledForgotPasswordLink = styled(AuthLink)({
  marginBottom: 12,
});

const ErrorText = styled('div')(props => ({
  fontSize: 14,
  fontWeight: 400,
  color: props.theme.palette.error.light,
}));

const Login = ({
  onEmailChange,
  onPasswordChange,
  onSubmit,
  email,
  password,
  error,
  isLoading,
}: ILogin) => {
  const { t } = useTranslation();
  
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onEmailChange(e.target.value);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onPasswordChange(e.target.value);
  };

  return (
    <AuthPage>
      <FormCard onSubmit={onSubmit}>
        <AuthInputsContainer>
          <StyledInput
            id="email"
            name="email"
            autoComplete="username"
            onChange={handleEmailChange}
            value={email}
            placeholder={t('auth.email')}
            type="email"
          />
          <StyledInput
            id="password"
            name="password"
            autoComplete="current-password"
            onChange={handlePasswordChange}
            value={password}
            placeholder={t('auth.password')}
            type="password"
          />
          {!!error && <ErrorText>{error}</ErrorText>}
          <Button text={t('auth.signIn')} isLoading={isLoading} />
          <StyledForgotPasswordLink
            mainText={t('auth.forgotPassword')}
            linkText={t('auth.resetHere')}
            link={ROUTES.FORGOT_PASSWORD.path}
          />
          <AuthLink mainText={t('auth.noAccount')} linkText={t('auth.signUp')} link={ROUTES.REGISTRATION.path} />
        </AuthInputsContainer>
      </FormCard>
      <SupportButton />
    </AuthPage>
  );
};

export default Login;
